import { createSlice } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";
import { createSelector } from "reselect";
import {
  setSelectedToFalseExceptPackage,
  setSelectedToFalseExceptSelected,
} from "./helperfuncs";

const slice = createSlice({
  name: "products",
  initialState: {
    list: [],
    productsSelected: [],
  },
  reducers: {
    productsReceived: (products, action) => {
      products.list = setSelectedToFalseExceptPackage(action.payload);
    },
    productAdded: (products, action) => {
      products.productsSelected.push(action.payload);
    },
    productRemoved: (products, action) => {
      products.productsSelected = products.productsSelected.filter(
        (item) => item !== action.payload
      );
    },

    changeSelectedProduct: (products, action) => {
      products.list = setSelectedToFalseExceptSelected(
        products.list,
        action.payload
      );
    },
  },
});

export const {
  productsReceived,
  productAdded,
  productRemoved,
  changeSelectedProduct,
} = slice.actions;

export default slice.reducer;

// action creator
export const loadProducts = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/products",
    method: "get",
    data: data,
    onSuccess: productsReceived.type,
  });

// Selector

export const getProductList = createSelector(
  (state) => state.entities.products,
  (products) => products.list
);

export const getProductsSelected = createSelector(
  (state) => state.entities.products,
  (products) => products.productsSelected
);
